"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_base64_1 = require("js-base64");
/**
 * Helper to encode and decode LIA entity IDs used in GraphQL.
 */
// eslint-disable-next-line unicorn/no-static-only-class
class IdConverter {
    /**
     * Encodes the type and internal ID of an entity into the ID used by GraphQL.
     *
     * @param tenant - The tenant
     *
     * @param typeAndId - The type and internal ID of the entity.
     * @return the GraphQL ID for an entity or <code>null</code> if invalid type and ID provided.
     */
    static encodeId(tenant, typeAndId) {
        if (typeAndId) {
            if (typeof typeAndId === 'string') {
                return tenant.useEncodedIds ? js_base64_1.Base64.encode(typeAndId) : typeAndId;
            }
            const tuple = typeAndId;
            const id = `${tuple.type}:${tuple.id}`;
            return tuple.type && tuple.id ? (tenant.useEncodedIds ? js_base64_1.Base64.encode(id) : id) : null;
        }
        return null;
    }
    /**
     * Decodes the GraphQL ID into a compound string that contains the entity type
     * and internal ID.
     *
     * @param tenant - The tenant
     *
     * @param id - The GraphQL ID
     * @return the decoded GraphQL ID as a string in the format: <type>:<id>
     */
    static decodeId(tenant, id) {
        return tenant.useEncodedIds ? js_base64_1.Base64.decode(id) : id;
    }
    /**
     * Decodes the GraphQL ID into an object that contains the entity type
     * and internal ID.
     *
     * @param tenant - The tenant
     *
     * @param id - The GraphQL ID
     * @return the decoded GraphQL ID as an object.
     */
    static decodeIdAsParts(tenant, id) {
        const typeAndId = IdConverter.decodeId(tenant, id);
        const [type, unscopedId] = typeAndId.split(':');
        return {
            type,
            id: unscopedId
        };
    }
    /**
     * Is this an optimistic ID.
     *
     * @param tenant - The tenant
     *
     * @param id - The GraphQL ID
     * @return whether or not the ID is optimistic.
     */
    static isOptimistic(tenant, id) {
        var _a;
        return !id || ((_a = IdConverter.decodeId(tenant, id)) === null || _a === void 0 ? void 0 : _a.endsWith('|temp'));
    }
}
exports.default = IdConverter;
//# sourceMappingURL=IdConverter.js.map